import React from 'react';
import { Feather, Thermometer, Target, Zap } from 'lucide-react';
import { IMAGES } from '../utils/constants';

const AboutSection = () => {
  return (
    <section id="about" className="about-section section-padding bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="section-header text-center mb-16">
          <h2 className="section-title">Who We Are</h2>
          <div className="title-underline" />
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="about-content space-y-6">
            <p className="text-lg text-slate-700 leading-relaxed">
              We are a materials innovation initiative focused on developing next-generation aerogel-based solutions that address critical challenges in energy efficiency, thermal safety, and lightweight engineering.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              Our work bridges advanced material science and real-world industrial deployment, with a strong focus on scalable, application-ready aerogel systems.
            </p>
            
            <div className="values-grid grid grid-cols-2 gap-6 mt-8">
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <Feather className="w-6 h-6" />
                </div>
                <p className="value-text">Ultra-lightweight performance</p>
              </div>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <Thermometer className="w-6 h-6" />
                </div>
                <p className="value-text">Thermal and energy efficiency</p>
              </div>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <Target className="w-6 h-6" />
                </div>
                <p className="value-text">Design flexibility across industries</p>
              </div>
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <Zap className="w-6 h-6" />
                </div>
                <p className="value-text">India-led deep-tech innovation</p>
              </div>
            </div>
          </div>
          
          <div className="about-image-wrapper">
            <img 
              src={IMAGES.about} 
              alt="Advanced Material Science" 
              className="about-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
